import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { theme } from 'theme/theme';
import Routes from 'shared/Routes';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { userActions } from 'actions/userActions';
import { CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  spinner: {
    margin: '20% 48%',
  },
}));

function App() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const isLoggedIn = useSelector(
    (state: ApplicationState) => state.isLoggedIn?.isLoggedIn,
  );

  const userAccess = useSelector(
    (state: ApplicationState) => state.isLoggedIn?.userAccess,
  );

  const [isReady, setIsReady] = useState<boolean>(!!userAccess);

  useEffect(() => {
    if (!isLoggedIn) {
      setIsReady(true);
      return;
    }
    if (userAccess) {
      setIsReady(true);
    } else {
      setIsReady(false);
      dispatch(userActions.getUserInfo());
    }
  }, [userAccess]);

  return (
    <React.Fragment>
      <Helmet
        titleTemplate="%s | LogStackPro Admin"
        defaultTitle="LogStackPro Admin"
      />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {isReady || !isLoggedIn ? (
          <Routes />
        ) : (
          <CircularProgress
            color="secondary"
            size={'6rem'}
            className={classes.spinner}
          />
        )}
      </ThemeProvider>
    </React.Fragment>
  );
}

export default App;
